import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import { category } from '../data';

const spanStyle = {
  padding: '20px',
  background: '#efefef',
  color: '#000000'
}

const divStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundSize: 'cover',
  height: '10vh',
}

export default function Slideshow(){

    return (
        <div className="slide-container slideshow">
          <p className='center'>shortcut to my projects</p>
        <Slide>
         {category.map((category)=> (
           <div key={category.title}>
              <div style={{ ...divStyle, 'backgroundImage': `url(${category.src})` }}>
                <span style={spanStyle}>{category.title}</span>
              </div>
            </div>
          ))} 
        </Slide>
      </div>
    )
}

